import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

function Landing() {
  const [copied, setCopied] = useState(false);
  const {inView , ref} = useInView();


  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  function copyAdress() {
    navigator.clipboard.writeText("diamondpe.us.to:19132");
    setCopied(true);
  }

  return (
    <header id="landing" ref={ref}>
      <div className="container">
        <div className={`${inView ? "content" : "hidden"}`}>
          <h4>The Best PE SkyBlock</h4>
          <h1>Diamond-PE</h1>
          <p>
            Looking for a thrilling adventure in Minecraft?
            <br />
            Introducing Diamond - PE one of the BEST PE Skyblock with amazing
            adventures. You start by building an empire from scratch and
            attacking other empires. Sounds fun right you also get to collect
            resources and enter different dimensions. Participate in events
            engaging with your friend and also making new friends. Click Here To
            Sign Up And Join The Fun.
          </p>
        </div>
        <button onClick={copyAdress} className={`${inView ? "content--button btn" : "hidden"}`}>
          Copy adress{" "}
          {copied && (
            <span className="check">
              <FontAwesomeIcon icon="fa-check" />{" "}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}

export default Landing;
